var React = require('react');

function IconCircledPlus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Fill 1"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"fill":"#768D99"},React.createElement("path",{"d":"M9.454,7.5 L7.5,7.5 L7.5,9.454 L5.5,9.454 L5.5,7.5 L3.545,7.5 L3.545,5.5 L5.5,5.5 L5.5,3.545 L7.5,3.545 L7.5,5.5 L9.454,5.5 L9.454,7.5 Z M6.411,-1.77635684e-15 C2.878,-1.77635684e-15 -1.11199938e-12,2.87 -1.11199938e-12,6.411 C-1.11199938e-12,9.945 2.87,12.823 6.411,12.823 C9.945,12.823 12.823,9.952 12.823,6.411 C12.823,2.878 9.952,-1.77635684e-15 6.411,-1.77635684e-15 L6.411,-1.77635684e-15 Z"})))]);
}

IconCircledPlus.defaultProps = {"width":"13px","height":"13px","viewBox":"0 0 13 13","version":"1.1"};

module.exports = IconCircledPlus;

IconCircledPlus.default = IconCircledPlus;
